(() => {
  function init(scope = document) {
    scope.querySelectorAll('[data-product-section]').forEach(section => {
      const stage = section.querySelector('.wa-gallery-stage');
      if (!stage || stage.dataset.galleryReady) return;
      stage.dataset.galleryReady = 'true';
      const thumbs = [...section.querySelectorAll('[data-gallery-src]')];
      const dialog = section.querySelector('[data-gallery-dialog]');
      const full = dialog?.querySelector('img');
      const counter = stage.querySelector('[data-gallery-count]');
      const main = stage.querySelector('.wa-gallery-main');
      let index = 0;
      const sync = () => {
        index = Math.max(0, thumbs.findIndex(t => t.classList.contains('is-active')));
        if (counter) counter.textContent = `${index + 1} / ${thumbs.length}`;
        if (dialog?.open && full) { full.src = thumbs[index].dataset.gallerySrc; full.alt = thumbs[index].dataset.galleryAlt; }
      };
      const select = direction => { index = (index + direction + thumbs.length) % thumbs.length; thumbs[index].click(); thumbs[index].scrollIntoView({block:'nearest',inline:'nearest',behavior:'instant'}); };
      stage.querySelectorAll('[data-gallery-step]').forEach(button => { button.hidden = thumbs.length < 2; button.addEventListener('click', () => select(Number(button.dataset.galleryStep))); });
      thumbs.forEach(t => t.addEventListener('click', () => requestAnimationFrame(sync)));
      section.querySelector('.wa-gallery-thumbs')?.addEventListener('keydown', e => { if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); select(e.key === 'ArrowRight' ? 1 : -1); thumbs[index].focus({preventScroll:true}); } });
      let start = null;
      stage.addEventListener('touchstart', e => { start = {x:e.touches[0].clientX,y:e.touches[0].clientY}; }, {passive:true});
      stage.addEventListener('touchend', e => { if (!start) return; const dx=e.changedTouches[0].clientX-start.x,dy=e.changedTouches[0].clientY-start.y; if(Math.abs(dx)>50&&Math.abs(dx)>Math.abs(dy)*1.4) select(dx<0?1:-1); start=null; }, {passive:true});
      const open = stage.querySelector('[data-gallery-enlarge]');
      if (dialog && open && main) {
        open.hidden = false;
        open.addEventListener('click', () => { full.src=main.currentSrc||main.src;full.alt=main.alt;dialog.showModal();document.body.style.overflow='hidden'; });
        dialog.querySelector('[data-gallery-close]').addEventListener('click', () => dialog.close());
        dialog.addEventListener('close', () => {document.body.style.overflow='';open.focus({preventScroll:true});});
        dialog.addEventListener('click', e => { if(e.target===dialog) dialog.close(); });
        dialog.addEventListener('keydown', e => {if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();select(e.key==='ArrowRight'?1:-1);}});
      }
      sync();
    });
  }
  init(); document.addEventListener('shopify:section:load', e => init(e.target));
})();
